var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDryCleaning = function SvgDryCleaning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13 10a1 1 0 11-2 0 1 1 0 012 0zM12 15a1 1 0 100-2 1 1 0 000 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.106 1.553A1 1 0 017 1h10a1 1 0 01.894.553l.815 1.63 1.24.412A3 3 0 0122 6.442V20a3 3 0 01-3 3H5a3 3 0 01-3-3V6.442a3 3 0 012.051-2.847l1.24-.413.815-1.63zm-.613 3.67l-.81.27A1 1 0 004 6.442V20a1 1 0 001 1h14a1 1 0 001-1V6.442a1 1 0 00-.684-.95l-.81-.269-1.612 3.224a1 1 0 01-1.341.447L12 7.118 8.447 8.894a1 1 0 01-1.341-.447L5.493 5.223zm8.352.582l1.708.853L16.882 4l-.223-.446-2.814 2.25zM9.851 3L12 4.72 14.15 3h-4.3zm.304 2.805l-1.708.853L7.118 4l.223-.446 2.814 2.25z"
  }))));
};
export default SvgDryCleaning;